// 数据回收请求工具类

import mqtt_protocol from "../mqtt-agreement/mqtt_protocol";
let gtdId = require('./../common').gtdId;
import CBean from './bean';

var Recovery = {};

Recovery.Department = function () {
    return recovery('02');
};

Recovery.Group = function () {
    return recovery('03');
};

Recovery.PLU = function () {
    return recovery('04');
};

Recovery.BarCode = function () {
    return recovery('05');
};

Recovery.Put = function () {
    return recovery('06');
};

Recovery.Assistant = function () {
    return recovery('07');
};

Recovery.Data = function () {
    return recovery('08');
};

Recovery.Text = function () {
    return recovery('09');
};

Recovery.Keyboard = function () {
    return recovery('0A');
};

Recovery.Character_bank = function () {
    return recovery('0B');
};

Recovery.Bitmaps = function () {
    return recovery('0C');
};

Recovery.Remote_print = function () {
    return recovery('0E');
};

Recovery.Remote_print = function () {
    return recovery('0E');
};

Recovery.Communication_hardware = function () {
    return recovery('FF', '00');
};

Recovery.Communication_discern = function () {
    return recovery('FF', '01');
};

Recovery.Communication_date = function () {
    return recovery('FF', '02');
};

/**
 * 汽车衡数据参数
 * @returns {any}
 * @constructor
 */
Recovery.Truck_data = function (dIds) {
    return recoveries("0201", dIds)
};

/**
 * 全部回收
 * @param dSort
 * @param dId
 * @returns {any}
 */
var recovery = function (dSort, dId) {
    var ret = JSON.parse(JSON.stringify(CBean.request)),
        arr = [],
        bean = {};
    bean.dId = dId ? gtdId(dId) : '00';
    bean.dSort = dSort;
    bean.dData = '';
    arr.push(bean);
    ret.dataParts = arr;
    return ret;
};

/**
 * 兼容指定回收
 * @param dSort
 * @param dIds
 * @returns {any}
 */
var recoveries = function (dSort, dIds) {
  // debugger;
    var ret = JSON.parse(JSON.stringify(CBean.request)),
        arr = [];
    if (dIds && dIds.length > 0) {
      if(dIds instanceof Array){
        for (var i in dIds) {
          console.log(dIds[i]);
          var bean = {};
          bean.dId = gtdId(dIds[i]);
          bean.dSort = dSort;
          bean.dData = '';
          arr.push(bean);
        }
      }else{
        var bean = {};
        bean.dId = gtdId(dIds);
        bean.dSort = dSort;
        bean.dData = '';
        arr.push(bean);
      }
    } else {
        var bean = {};
        bean.dId = '00';
        bean.dSort = dSort;
        bean.dData = '';
        arr.push(bean);
    }
    ret.dataParts = arr;
    return ret;
};

export default Recovery;
// export default Recovery = {
//   Truck_data:Recovery.Truck_data
// };



//////////////////
// WEBPACK FOOTER
// ./api/agreement/cr-agreement/recovery.js
// module id = null
// module chunks = 